import { useCurrentPlatformQuery } from "@/partner/entities/platforms";
import { useAbility } from "@/partner/shared/lib";

/**
 * Показывать ли записи 2257 текущему сотруднику: платформа с включённым
 * комплаенсом (спека §4) и право на ComplianceRecord. Правила приходят с
 * бэкенда (PartnerPolicy): записи содержат паспортные данные исполнителей,
 * поэтому доступны только роли admin организации (решение 2026-09-07).
 */
export const useComplianceEnabled = (): boolean => {
  const { data: platformData } = useCurrentPlatformQuery();
  const ability = useAbility();
  return (
    Boolean(platformData?.currentPlatform?.isComplianceEnabled) &&
    ability.can("read", "ComplianceRecord")
  );
};
